module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture",
    style: ({
      backgroundImage: ("url(" + _vm.image_background + ")")
    })
  }), _c('div'), _c('div', {
    staticClass: "info_show_song flex"
  }, [_c('Canvas-video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBack),
      expression: "showBack"
    }],
    ref: "videocan",
    staticStyle: {
      "z-index": "-9",
      "width": "100vw !important",
      "height": "137vh !important",
      "top": "-20vh !important",
      "position": "fixed !important"
    },
    attrs: {
      "src": _vm.video_background,
      "cover": true,
      "loop": true
    }
  }), _c('q-carousel', {
    ref: "infogene",
    attrs: {
      "infinite": "infinite",
      "no-swipe": "no-swipe"
    }
  }, [_c('div', {
    staticClass: "navigationsongs"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left historyarrowleft fa-3x-ns fa-2x",
    on: {
      "click": function($event) {
        _vm.checkSlide('previous')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-arrow-right historyarrowright fa-3x-ns fa-2x",
    on: {
      "click": function($event) {
        _vm.checkSlide('next')
      }
    }
  })]), _c('div', {
    slot: "slide"
  }, [_c('img', {
    staticClass: "logosongs",
    attrs: {
      "src": _vm.data_tri[0].container.medias[0].image.url,
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "titrehistory flex mv3"
  }, [_c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  }), _c('div', {
    staticClass: "history white ttu mh3"
  }, [_vm._v("About the song")]), _c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  })]), _c('div', {
    staticClass: "introhistory",
    domProps: {
      "innerHTML": _vm._s(_vm.page.description)
    }
  }), _c('q-btn', {
    staticClass: "historybtn",
    attrs: {
      "label": "Open"
    },
    on: {
      "click": function($event) {
        _vm.openModalBasic()
      }
    }
  }, [_vm._v("Read more")])], 1), _c('div', {
    slot: "slide"
  }, [_c('img', {
    staticClass: "logosongs",
    attrs: {
      "src": _vm.data_tri[0].container.medias[0].image.url,
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "titrehistory flex mv3"
  }, [_c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  }), _c('div', {
    staticClass: "history white ttu mh3"
  }, [_vm._v("Songwriter")]), _c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  })]), _c('div', {
    staticClass: "introhistory",
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[1].container.description)
    }
  }), _c('q-btn', {
    staticClass: "historybtn",
    attrs: {
      "label": "Open"
    },
    on: {
      "click": function($event) {
        _vm.modalChanteur()
      }
    }
  }, [_vm._v("Read more")])], 1), _c('div', {
    slot: "slide"
  }, [_c('div', {
    staticStyle: {
      "z-index": "80",
      "top": "0"
    }
  }, [_c('img', {
    staticClass: "logosongs",
    attrs: {
      "src": _vm.data_tri[0].container.medias[0].image.url,
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "titrehistory flex mv3"
  }, [_c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  }), _c('div', {
    staticClass: "history white ttu mh3"
  }, [_vm._v("Song Recording")]), _c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  })]), _c('div', {
    staticClass: "introhistory",
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[4].container.description)
    }
  }), _c('q-btn', {
    staticClass: "historybtn",
    on: {
      "click": function($event) {
        _vm.modalSong()
      }
    }
  }, [_vm._v("play")])], 1)])]), _c('q-modal', {
    ref: "songModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        padding: '-1px',
        background: 'transparent'
      }
    },
    on: {
      "close": function($event) {
        _vm.closeSong()
      }
    }
  }, _vm._l((_vm.data_tri[4].container.medias), function(med) {
    return (_vm.openSong) ? _c('div', [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "width": "80vw",
        "height": "45vh"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    })], 1)]) : _vm._e()]) : _vm._e()
  })), _c('q-modal', {
    ref: "basicModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        background: 'black',
        border: 'solid 2px white'
      }
    },
    on: {
      "close": function($event) {
        _vm.closeBasic()
      }
    }
  }, [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.data_tri[2].container.titre))]), _vm._l((_vm.data_tri[2].container.medias), function(med) {
    return (_vm.openBasic) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', [_c('img', {
      attrs: {
        "src": med.image.url,
        "width": "90%",
        "height": "90%"
      }
    })]) : _vm._e()]) : _vm._e()
  }), _c('div', {
    staticClass: "blocdescription2"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[2].container.description)
    }
  })]), _vm._l((_vm.data_tri[2].container.medias), function(med) {
    return (_vm.openBasic) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "height": "300px"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    }), _c('p', [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()]) : _vm._e()
  })], 2), _c('q-modal', {
    ref: "chanteurModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        background: 'black',
        border: 'solid 2px white'
      }
    },
    on: {
      "close": _vm.closeChanteur
    }
  }, [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.data_tri[3].container.titre))]), _c('div', {
    staticClass: "blocdescription2"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[3].container.description)
    }
  })]), _vm._l((_vm.data_tri[3].container.medias), function(med) {
    return _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', [_c('img', {
      attrs: {
        "src": med.image.url,
        "width": "90%",
        "height": "90%"
      }
    })]) : _vm._e()])
  }), _vm._l((_vm.data_tri[3].container.medias), function(med) {
    return (_vm.openChanteur) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    }), _c('p', [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()]) : _vm._e()
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d617825","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Song/Info.vue
// module id = 1280
// module chunks = 1